var render = function () {
  var _vm$value, _vm$value$resume, _vm$value$resume$prof, _vm$value2, _vm$value2$resume, _vm$value2$resume$pro, _vm$value3, _vm$value3$resume, _vm$value3$resume$per, _vm$value4, _vm$value4$resume, _vm$value4$resume$per, _vm$value5, _vm$value5$resume, _vm$value5$resume$per, _vm$value6, _vm$value7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align-lg": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-simple-checkbox', {
    attrs: {
      "value": _vm.isSelected
    },
    on: {
      "click": _vm.select
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey"
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$resume = _vm$value.resume) === null || _vm$value$resume === void 0 ? void 0 : (_vm$value$resume$prof = _vm$value$resume.profile) === null || _vm$value$resume$prof === void 0 ? void 0 : _vm$value$resume$prof.url
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$value2 = _vm.value) !== null && _vm$value2 !== void 0 && (_vm$value2$resume = _vm$value2.resume) !== null && _vm$value2$resume !== void 0 && (_vm$value2$resume$pro = _vm$value2$resume.profile) !== null && _vm$value2$resume$pro !== void 0 && _vm$value2$resume$pro.url),
      expression: "!value?.resume?.profile?.url"
    }],
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-account")])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px"
  }, [_vm._v(" " + _vm._s((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$resume = _vm$value3.resume) === null || _vm$value3$resume === void 0 ? void 0 : (_vm$value3$resume$per = _vm$value3$resume.personalInformation) === null || _vm$value3$resume$per === void 0 ? void 0 : _vm$value3$resume$per.name) + " ")]), _c('p', {
    staticClass: "page-text grey-9--text"
  }, [_vm._v("(" + _vm._s((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : (_vm$value4$resume = _vm$value4.resume) === null || _vm$value4$resume === void 0 ? void 0 : (_vm$value4$resume$per = _vm$value4$resume.personalInformation) === null || _vm$value4$resume$per === void 0 ? void 0 : _vm$value4$resume$per.genderText) + ", " + _vm._s((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : (_vm$value5$resume = _vm$value5.resume) === null || _vm$value5$resume === void 0 ? void 0 : (_vm$value5$resume$per = _vm$value5$resume.personalInformation) === null || _vm$value5$resume$per === void 0 ? void 0 : _vm$value5$resume$per.age) + ")")])])], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "recruit-list-item__detail mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('ul', {
    staticClass: "dot-texts"
  }, _vm._l(_vm.cardTextList, function (text) {
    return _c('li', {
      key: text,
      staticClass: "dot-text page-text grey-6--text ellip"
    }, [_vm._v("· " + _vm._s(text))]);
  }), 0)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "10",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "w-100 w-lg-100px",
    attrs: {
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        return _vm.showApplicationView(5);
      }
    }
  }, 'v-btn', {
    color: (_vm$value6 = _vm.value) !== null && _vm$value6 !== void 0 && _vm$value6.isCertified ? 'secondary' : 'primary'
  }, false), [_vm._v("마이스펙인증")])], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 w-lg-100px",
    attrs: {
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.showApplicationView(3);
      }
    }
  }, [_vm._v("문자발송")])], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 w-lg-100px",
    attrs: {
      "outlined": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.showApplicationView(0);
      }
    }
  }, [_vm._v("지원자정보")])], 1)], 1)], 1), _c('v-spacer', {
    staticClass: "d-block d-lg-none"
  }), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "outlined": "",
      "small": "",
      "color": "grey-9"
    },
    on: {
      "click": function click($event) {
        return _vm.showApplicationView(4);
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-checkbox-multiple-blank-outline")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('like-btn', {
    attrs: {
      "params": {
        _application: (_vm$value7 = _vm.value) === null || _vm$value7 === void 0 ? void 0 : _vm$value7._id,
        type: _vm.USER_LIKE_TYPES.APPLICATION.value
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var active = _ref.active,
          toggle = _ref.toggle;
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": active ? 'yellow darken-1' : undefined
          },
          on: {
            "!click": function click($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return function () {
                return !_vm.selectable && toggle();
              }($event);
            }
          }
        }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('application-view', _vm._b({
    ref: "application-view",
    on: {
      "input": function input(item) {
        return _vm.$emit('input', item);
      }
    }
  }, 'application-view', {
    value: _vm.value,
    recruitment: _vm.recruitment
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }